import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotificationsPanel } from './notifications-panel.model';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { SignalRService, SIGNAL_R_LISTENERS } from 'app/shared/services/signalr.service';

@Injectable({
  providedIn: 'root',
})

export class NotificationPanelService {
  private notifications = new BehaviorSubject<NotificationsPanel[]>([]);
  notifications$ = this.notifications.asObservable();
  unreadCount$ = this.notifications$.pipe(
    map((notifications) => notifications.filter((n) => n.status === 'New').length)
  );

  constructor(private http: HttpClient, private signalRService: SignalRService) {
    this.signalRService.startInAppNotificationsConnection().subscribe(() => {
      this.listenForNotifications();
    });
  }

  listenForNotifications(): void {
    this.signalRService.listenToNotificationsEvent<NotificationsPanel>(SIGNAL_R_LISTENERS.ReceiveNotification).subscribe((notification) => {
      this.addNotification(notification);
    });
  }

  addNotification(notification: NotificationsPanel): void {
    const currentNotifications = this.notifications.getValue();
    this.notifications.next([notification, ...currentNotifications]);
  }

  fetchNotifications(params?: { [key: string]: any }): void {
    if (params?.['actionType']) {
      params['actionType'] = params['actionType'].replace(/\s+/g, '');
    }

    const httpParams = params ? new HttpParams({ fromObject: params }) : new HttpParams();

    this.http.get<NotificationsPanel[]>('/v1/notification-management/all', { params: httpParams }).subscribe(
      (data) => this.notifications.next(data)
    );
  }

  markNotificationAsRead(id: number): Observable<void> {
    return this.http.put<void>(`/v1/notification-management/read/${id}`, {}).pipe(
      map(() => {
        const currentNotifications = this.notifications.getValue();
        const updatedNotifications = currentNotifications.map((notification) =>
          notification.id === id ? { ...notification, status: 'Read' } : notification
        );
        this.notifications.next(updatedNotifications);
      })
    );
  }

  markAllNotificationsAsRead(): Observable<void> {
    return this.http.put<void>('/v1/notification-management/read/all', {}).pipe(
      map(() => {
        const currentNotifications = this.notifications.getValue();
        const updatedNotifications = currentNotifications.map((notification) => ({
          ...notification,
          status: 'Read',
        }));
        this.notifications.next(updatedNotifications);
      })
    );
  }
}
